import PropTypes from "prop-types";
import React, { useState } from "react";

import { deepCamelizeKeys } from "views_shared/app/javascript/utils/caseConversion";

import Tag from "../profiles/Tag";

function defaultHashtagUrlResolver(hashtag) {
  return `/hashtags/${hashtag.hashtagSlug}`;
}

function HashtagsCollapsible({
  hashtags: underscoredHashtags,
  collapseAt = 5,
  variant = "badges",
  onTagClick = null,
  highlight = [],
  hashtagUrlResolver = defaultHashtagUrlResolver,
}) {
  const hashtags = deepCamelizeKeys(underscoredHashtags);
  const [showAll, setShowAll] = useState(false);
  const limit = collapseAt;

  const tagsToHighlight = new Set(highlight);

  const handleShowAll = () => {
    setShowAll((prevShowAll) => !prevShowAll);
  };

  const renderLinksWithCommas = () => {
    const visibleHashtags = showAll ? hashtags : hashtags.slice(0, limit);

    return visibleHashtags.map((hashtag, index) => (
      <React.Fragment key={hashtag.hashtagName}>
        <a
          href={hashtagUrlResolver(hashtag)}
          onClick={onTagClick && ((event) => onTagClick(hashtag.hashtagName, event))}
        >
          {hashtag.hashtagName}
        </a>
        {index < visibleHashtags.length - 1 ? ", " : ""}
      </React.Fragment>
    ));
  };

  const renderWithBadges = () => {
    const visibleHashtags = showAll ? hashtags : hashtags.slice(0, limit);

    return visibleHashtags.map((hashtag) => {
      const { hashtagName } = hashtag;
      return (
        <Tag
          key={hashtagName}
          href={hashtagUrlResolver(hashtag)}
          selected={tagsToHighlight.has(hashtagName)}
          onClick={onTagClick && ((event) => onTagClick(hashtagName, event))}
          className="m-1"
        >
          {hashtagName}
        </Tag>
      );
    });
  };

  const remainingCount = hashtags.length - limit;
  return (
    <span>
      {variant === "badges" ? renderWithBadges() : renderLinksWithCommas()}
      {remainingCount > 0 && (
        <button type="button" className="btn btn-link p-0 ms-2 small text-muted" onClick={handleShowAll}>
          {showAll ? "Show Less" : `Show ${remainingCount} more`}
        </button>
      )}
    </span>
  );
}

HashtagsCollapsible.propTypes = {
  hashtags: PropTypes.arrayOf(
    PropTypes.shape({
      // we accept both under_scored and camelCase keys here
      hashtagName: PropTypes.string,
      hashtag_name: PropTypes.string,
      hashtagSlug: PropTypes.string,
      hashtag_slug: PropTypes.string,
    }),
  ).isRequired,
  collapseAt: PropTypes.number,
  variant: PropTypes.oneOf(["badges", "links"]),
  onTagClick: PropTypes.func,
  highlight: PropTypes.arrayOf(PropTypes.string),
  hashtagUrlResolver: PropTypes.func,
};

export default HashtagsCollapsible;
